<template>
  <div>
    <el-card>
      <el-row class="auto_replay__title">客服自助问题</el-row>
      <!-- 搜索 -->
      <el-row class="auto_replay__search">
        <span>渠道：</span>
        <el-select
          style="width: 160px"
          class="header-item"
          v-model="search.channel"
          placeholder="选择渠道"
          clearable
          filterable
        >
          <el-option
            v-for="(item, itemIndex) in channelList"
            :key="itemIndex"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- <span>状态：</span>
        <el-select
          v-model="search.valid"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="全部" :value="null"> </el-option>
          <el-option label="下线" :value="0"> </el-option>
          <el-option label="上线" :value="1"> </el-option>
        </el-select> -->
        <el-button style="margin-left: 10px" type="primary" @click="getList(1)"
          >查询</el-button
        >
        <el-button
          style="margin-top: 10px"
          type="primary"
          @click="
            () => {
              dialogType = 0
              dialogShow = true
            }
          "
          >新增</el-button
        >
      </el-row>
      <!-- 表格 -->
      <el-row>
        <el-table
          border
          :data="tableList"
          row-key="id"
          :tree-props="{ children: 'children' }"
        >
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="channel" label="渠道" align="center">
          </el-table-column>
          <el-table-column prop="type" label="问题分类" align="center">
          </el-table-column>
          <el-table-column prop="que" label="问题类别" align="center">
          </el-table-column>
          <el-table-column prop="ans" label="问题答案" align="center">
          </el-table-column>
          <el-table-column prop="valid" label="状态" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.row.valid == 0 ? '下线' : '上线' }} -->
              <el-tag v-if="scope.row.valid == 1" type="success">上线</el-tag>
              <el-tag v-else type="danger">下线</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="380"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                v-if="scope.row.zindex == 1 || !scope.row.zindex"
                @click="
                  () => {
                    form = JSON.parse(JSON.stringify(scope.row))
                    dialogType = 1
                    dialogShow = true
                  }
                "
                >编辑</el-button
              >
              <el-button
                v-if="
                  scope.row.valid == 0 &&
                  (scope.row.zindex == 1 || !scope.row.zindex)
                "
                type="success"
                @click="
                  () => {
                    const info = reverseMerge(scope.row)
                    info.valid = 1
                    updataInfo(info)
                  }
                "
                >上线</el-button
              >
              <el-button
                v-else
                type="info"
                @click="deleteTemplate(scope.row)"
                >{{
                  scope.row.zindex == 1 || !scope.row.zindex ? '下线' : '删除'
                }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 配置弹窗 -->
      <el-dialog
        @close="close"
        :visible.sync="dialogShow"
        :title="dialogType == 0 ? '创建' : '更新'"
      >
        <el-form ref="Form" :model="form" label-width="120px">
          <el-form-item label="渠道">
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="form.channel"
              placeholder="选择渠道"
              clearable
              filterable
            >
              <el-option
                v-for="(item, itemIndex) in channelList"
                :key="itemIndex"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="form.valid"
              style="width: 100px"
              placeholder="请选择"
              clearable
            >
              <el-option label="下线" :value="0"> </el-option>
              <el-option label="上线" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <div
            class="model"
            style="
              margin: 5px;
              padding: 20px 0;
              border: 1px solid #ccc;
              border-radius: 10px;
            "
            v-for="(item, index) in form.children"
            :key="index"
          >
            <el-form-item label="问题分类">
              <el-select
                style="width: 160px"
                class="header-item"
                v-model="item.type"
                placeholder="选择分类"
                clearable
                filterable
                allow-create
              >
                <el-option
                  v-for="(items, itemIndex) in types"
                  :key="itemIndex"
                  :label="items"
                  :value="items"
                ></el-option>
              </el-select>
            </el-form-item>
            <div
              class="model_children"
              v-for="(itemsC, indC) in item.children"
              :key="indC"
              style="
                padding: 10px;
                border: 1px dotted #ccc;
                margin: 10px;
                border-radius: 10px;
              "
            >
              <el-form-item label="问题类型">
                <el-select
                  style="width: 160px"
                  class="header-item"
                  v-model="itemsC.que"
                  placeholder="选择类型"
                  clearable
                  filterable
                  allow-create
                >
                  <el-option
                    v-for="(items, itemIndex) in questions"
                    :key="itemIndex"
                    :label="items"
                    :value="items"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="问题原因">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  v-model="itemsC.ans"
                >
                </el-input>
              </el-form-item>
              <el-row style="margin: 10px">
                <el-button type="danger" @click="item.children.splice(indC, 1)"
                  >删除</el-button
                >
              </el-row>
            </div>
            <el-row style="margin: 10px">
              <el-button type="danger" @click="form.children.splice(index, 1)"
                >删除</el-button
              >
              <el-button
                type="primary"
                @click="
                  () => {
                    item.children.push({
                      que: null,
                      ans: null,
                    })
                  }
                "
                >添加</el-button
              >
            </el-row>
          </div>
          <el-row style="margin: 10px">
            <el-button
              type="success"
              @click="
                () => {
                  form.children.push({
                    type: null,
                    children: [
                      {
                        que: null,
                        ans: null,
                      },
                    ],
                  })
                }
              "
              >添加</el-button
            >
          </el-row>
          <el-row>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submit">{{
              dialogType == 0 ? '创建' : '修改'
            }}</el-button>
          </el-row>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { id } from 'vue-json-editor/assets/jsoneditor'

export default {
  data() {
    return {
      search: {
        valid: null,
        channel: null,
      },
      // 0 新增 1 编辑
      dialogType: 0,
      dialogShow: false,
      tableList: [],
      channelList: [],
      types: [],
      questions: [],
      form: {
        channel: null,
        valid: 1,
        children: [
          {
            type: null,
            children: [
              {
                que: null,
                ans: null,
              },
            ],
          },
        ],
      },
    }
  },
  created() {
    this.getList()
    this.getChannel()
  },
  methods: {
    close() {
      this.form = {
        channel: null,
        valid: 1,
        children: [
          {
            type: null,
            children: [
              {
                que: null,
                ans: null,
              },
            ],
          },
        ],
      }
      this.dialogShow = false
    },
    // 编辑
    copyOrUpdate(info) {
      console.log(info)
    },
    // 获取数据列表
    async getList() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.replay_auto_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.search,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.tableList = res.data
        ;[this.types, this.questions] = this.getArraysFromArray(res.data)
        this.tableList.map((item) => {
          this.formatterData(item)
        })
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    submit() {
      this.updataInfo(this.reverseMerge(this.form))
    },
    // 编辑数据
    async updataInfo(info) {
      const infos = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.dialogType == 0
            ? this.$store.getters.path.replay_auto_add
            : this.$store.getters.path.replay_auto_post,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: infos,
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success(this.dialogType == 0 ? '创建成功' : '修改成功')
        this.close()
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 删除数据
    async deleteInfo(id) {
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.replay_auto_delete,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          id,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 删除
    deleteTemplate(info) {
      if (info.zindex == 1) {
        this.deleteInfo(info.id)
      } else {
        const ind = this.tableList.findIndex((item) => item.id == info.paId)
        this.$set(this.tableList, ind, {
          ...this.tableList[ind],
          children: this.deleteChildren(this.tableList[ind].children, info.id),
        })
        this.updataInfo(this.reverseMerge(this.tableList[ind]))
      }
    },
    deleteChildren(children, id) {
      return children.filter((item) => {
        if (item.id == id) {
          return false
        }

        if (item.children && item.children.length > 0) {
          item.children = this.deleteChildren(item.children, id)
        }

        return true
      })
    },
    // 获取问题分类和类别
    getArraysFromArray(arr) {
      const topLevelKeys = new Set()
      const nestedKeys = new Set()

      // 如果输入数组为空或没有有效的 replyConfig，直接返回空数组
      if (!arr || arr.length === 0) {
        return [[], []]
      }

      // 遍历数组中的每个对象
      arr.forEach((item) => {
        if (item.replyConfig) {
          const realConfig = item.replyConfig

          // 获取 replyConfig 中的顶级键
          Object.keys(realConfig).forEach((key) => {
            topLevelKeys.add(key) // 使用 Set 保证唯一性

            // 获取该键下嵌套对象的键
            if (
              typeof realConfig[key] === 'object' &&
              realConfig[key] !== null
            ) {
              Object.keys(realConfig[key]).forEach((nestedKey) => {
                nestedKeys.add(nestedKey) // 使用 Set 保证唯一性
              })
            }
          })
        }
      })

      // 如果没有提取到任何顶级键和嵌套键，返回空数组
      if (topLevelKeys.size === 0 && nestedKeys.size === 0) {
        return [[], []]
      }

      // 将 Set 转回数组
      return [Array.from(topLevelKeys), Array.from(nestedKeys)]
    },
    // 格式化数据
    formatterData(object) {
      if (JSON.stringify(object) === '{}' || !object.replyConfig) return object

      // 生成唯一 ID 的工具函数
      const generateId = () => Date.now() + Math.floor(Math.random() * 1000)

      // 格式化 replyConfig
      object.children = Object.entries(object.replyConfig).map(
        ([key, question]) => {
          const parentId = generateId() // 生成父级的唯一ID
          return {
            ...object,
            type: key,
            question,
            id: parentId, // 父级的ID
            zindex: 2,
            paId: object.id, // 父级的paId指向object.id
            children: Object.entries(question).map(([que, ans]) => ({
              ...object,
              type: key,
              que,
              ans,
              id: generateId(), // 子级的唯一ID
              paId: object.id, // 子级的paId指向父级的ID
              zindex: 3,
            })),
          }
        }
      )

      object.zindex = 1
      return object
    },
    reverseMerge(objects) {
      const replyConfig = {}
      const object = JSON.parse(JSON.stringify(objects))

      // 检查 object.children 是否存在
      if (object.children && Array.isArray(object.children)) {
        object.children.forEach((child) => {
          // console.log(child);
          const { type, children } = child

          // 初始化 replyConfig[type]
          replyConfig[type] = {}

          // 如果 children 存在且是数组，遍历并合并数据
          if (children && Array.isArray(children)) {
            children.forEach((subChild) => {
              const { que, ans } = subChild
              if (que && ans) {
                replyConfig[type][que] = ans
              }
            })
          }
        })
      }

      // 将重建的 replyConfig 赋值回 object
      object.replyConfig = replyConfig
      delete object.children // 删除 children，恢复原始结构
      delete object.zindex
      return object
    },
  },
}
</script>

<style scoped lang="scss">
.auto_replay {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>